export default "__VITE_ASSET__xpN2jw$a__"